import Vue from 'vue';
import Component from 'vue-class-component';
import Flatpickr from "flatpickr";
import ShortcutButtonsPlugin from "shortcut-buttons-flatpickr"
import { Prop, Inject } from 'vue-property-decorator';
import { Tooltip } from '../tooltip/tooltip';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

require('wc-lib/icons/calendar.svg');

require('../../../../icons/questioncircleo.svg');

export interface IFormDatepicker {
    pickedDate: Date
    pickedToDate: Date
}


@Component({
    template: require('./form-datepicker.html'),
    name: 'form-datepicker',
    components: {
        'wc-tooltip': Tooltip
    },

})
export class FormDatepicker extends Vue {
    private buttonsPluginConfig = {
        button: [
            {
                label: "Today"
            }
        ],
        label: "",
        onClick: (index, fp) => {
            let date;
            switch (index) {
                case 0:
                    let d = new Date();
                    let dy = d.getDate();
                    let y = d.getFullYear();
                    let m = d.getMonth();
                    date = new Date(y, m, dy);
                    break;
            }
            fp.setDate(date);
        }
    };
    @Inject()
    $validator;

    @Prop()
    label: string;

    @Prop()
    required: boolean;

    @Prop({
        default: true
    })
    inline: boolean;

    @Prop()
    help: string;

    @Prop({
        default: '___defaultName'
    })
    name: string;

    @Prop({
        default: 'column-25'
    })
    additionalClass: string;

    @Prop({
        default: null
    })
    defaultDate: Date;

    @Prop({
        default: null
    })
    defaultToDate: Date;

    @Prop({
        default: false
    })
    enableTime: boolean;

    @Prop({
        default: true
    })
    enableValidation: boolean;

    @Prop({
        default: () => {
            let d = new Date();
            let dy = d.getDate();
            let y = d.getFullYear();
            let m = d.getMonth();

            return new Date(y, m, dy);
        }
    })
    minDate: Date;

    @Prop({
        default: false
    })
    isRange: boolean;

    @Prop({
        default: false
    })
    showWeekNumbers: boolean;

    @Prop({
        default: false
    })
    allowNullInitialisation: boolean;

    @Prop({
        default: true
    })
    showTodayButton: boolean;

    @Prop({
        default: true
    })
    allowInput: boolean;

    get value(): IFormDatepicker {
        return { pickedDate: this._pickedDate, pickedToDate: this._pickedToDate };
    }

    set value(d: IFormDatepicker) {
        this._pickedDate = d.pickedDate;
        this._pickedToDate = d.pickedToDate;
    }

    static getEmptyIWcDatepicker(): IFormDatepicker {
        return { pickedDate: new Date(), pickedToDate: new Date() };
    }

    dateFormat: string = "d/m/Y";
    fp: any = null;
    fp2: any = null;

    _pickedDate: Date;
    _pickedToDate: Date;

    onButtonClick() {
        this.fp.open();
    }

    returnDateObject(): IFormDatepicker {

        if (this.fp.selectedDates[0]) {
            this._pickedDate = this.fp.selectedDates[0] as Date;
            this._pickedToDate = this.fp.selectedDates[0] as Date;
            if ((this.fp2) && (this.fp2.selectedDates[0])) {
                this._pickedToDate = this.fp2.selectedDates[0] as Date;
            }
        }
        return {
            pickedDate: this._pickedDate
            , pickedToDate: this._pickedToDate
        }
    }
    initialise() {

        let d = new Date();
        let dy = d.getDate();
        let y = d.getFullYear();
        let m = d.getMonth();

        let defaultDt = (this.defaultDate || this.allowNullInitialisation) ? this.defaultDate : new Date(y, m, dy);
        let defaultToDt = (this.defaultToDate || this.allowNullInitialisation) ? this.defaultToDate : new Date(y, m, dy);

        this._pickedDate = this.value && this.value.pickedDate ? new Date(this.value.pickedDate || defaultDt) : defaultDt;
        if (this.isRange)
            this._pickedToDate = this.value && this.value.pickedToDate ? new Date(this.value.pickedToDate || defaultToDt) : defaultToDt;



        let e: HTMLElement = this.$refs["dt-p"] as HTMLElement;
        this.fp = Flatpickr(e, {
            plugins: this.showTodayButton ? [ShortcutButtonsPlugin(this.buttonsPluginConfig)] : []
            , enableTime: this.enableTime
            , dateFormat: this.dateFormat //"Y-m-d H:i"
            , defaultDate: this.defaultDate
            , minDate: this.minDate
            , allowInput: this.allowInput
            , clickOpens: true
            , time_24hr: true
            , weekNumbers: this.showWeekNumbers
            , onChange: (selectedDates, dateStr, pickerInstance) => {

                this.$emit('input', this.returnDateObject());
            }
            , onClose: () => {
                if (this.isRange) {
                    if (this.fp.selectedDates[0]) {
                        this.$set(this.fp2.config, 'minDate', this.fp.selectedDates[0] as Date);
                    }
                    this.fp2.open();
                }
            }
        });
        let dis = this;
        e.addEventListener("blur", function () {
            let x: any = e;
            let xx = x._flatpickr;
            if (dis.allowInput == true && xx.selectedDates[0] && (xx.selectedDates[0] as Date).toLocaleDateString() != (xx.element.value)) {
                xx.setDate(xx.element.value, true, 'd/m/Y');
            }
        });

        if (this.isRange) {
            let e2: HTMLElement = this.$refs["dt-p2"] as HTMLElement;
            if (this.defaultToDate < this.defaultDate)
                this.defaultToDate = this.defaultDate;
            this.fp2 = Flatpickr(e2, {
                plugins: this.showTodayButton ? [ShortcutButtonsPlugin(this.buttonsPluginConfig)] : []
                , enableTime: this.enableTime
                , dateFormat: this.dateFormat //"Y-m-d H:i"
                , defaultDate: this.defaultToDate
                , minDate: this.minDate
                , allowInput: this.allowInput
                , clickOpens: true
                , time_24hr: true
                , weekNumbers: this.showWeekNumbers
                , onChange: (selectedDates, dateStr, instance) => {
                    this.$emit('input', this.returnDateObject());
                }
            });
            e2.addEventListener("blur", function () {
                let x: any = e2;
                let xx = x._flatpickr;
                if (dis.allowInput == true && xx.selectedDates[0] && (xx.selectedDates[0] as Date).toLocaleDateString() != (xx.element.value)) {
                    xx.setDate(xx.element.value, true, 'd/m/Y');
                }
            })
        }
        this.$emit('input', this.returnDateObject());
    }

    created() {

        this.$validator.extend(
            'aemoDateRangeValidation', {
            getMessage: 'From date cannot be after to date.',
            validate: (value) => {
                if (!(this.fp2.selectedDates[0] as Date))
                    value = false;
                if (!(this.fp.selectedDates[0] as Date))
                    value = false;
                let diff = (this.fp2.selectedDates[0] as Date).valueOf() - (this.fp.selectedDates[0] as Date).valueOf();
                if (diff < 0) {
                    value = false;
                }
                return value;
            }
        }
        );

    }

    mounted() {
        if (this.enableTime) {
            this.dateFormat = "d/m/Y H:i";
        }
        this.initialise();
    }

}




// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/form/form-datepicker.ts